var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "matkp" }, [
    _c(
      "div",
      { staticClass: "f-col fill-height" },
      [
        _c("matkp-nav", { attrs: { glass: "", showSearch: false } }),
        _c("matkp-hero"),
        _c(
          "div",
          {
            staticClass: "mat-body f-col align-h-center",
            staticStyle: { "max-width": "1400px", margin: "0 auto" },
          },
          [
            _c(
              "div",
              {
                staticClass: "f-col",
                staticStyle: { gap: "30px", width: "100%" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "f-row align-v-bottom",
                    staticStyle: {
                      padding: "50px 0 10px",
                      background: "none",
                      gap: "50px",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "hero-label f-row align-v-center align-h-center no-events",
                      },
                      [
                        _vm._m(0),
                        _c(
                          "div",
                          {
                            staticClass: "f-col",
                            staticStyle: { gap: "10px" },
                          },
                          [
                            _c("div", { staticClass: "tagline" }, [
                              _vm._v(
                                " An open community portal for adipose biology across multiple mammalian species "
                              ),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "f-col align-v-center yes-events",
                                staticStyle: {
                                  "z-index": "1",
                                  gap: "20px",
                                  height: "100%",
                                },
                              },
                              [_c("matkp-search")],
                              1
                            ),
                            _c("div", [
                              _vm._v(
                                " Search a gene for a summary of adipose knowledge from our portal. "
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._m(1),
            _c(
              "div",
              {
                staticClass: "f-row align-v-center",
                staticStyle: { gap: "20px", "min-width": "1160px" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "f-row fill-width",
                    staticStyle: {
                      gap: "20px",
                      padding: "40px",
                      background: "#ffffffcc",
                    },
                  },
                  [
                    _vm._m(2),
                    _c(
                      "div",
                      {
                        staticClass: "f-row fill-width",
                        staticStyle: { gap: "10px", padding: "25px 0 0" },
                      },
                      [
                        _vm._m(3),
                        _c(
                          "div",
                          {
                            staticClass: "f-col fill-width",
                            staticStyle: { gap: "10px" },
                          },
                          [
                            _c("div", {
                              staticClass: "yes-events",
                              staticStyle: { flex: "1" },
                              attrs: { id: "data-viz" },
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "f-row",
                                staticStyle: { gap: "10px" },
                              },
                              _vm._l(
                                _vm.$parent.secondaryLegend,
                                function (item) {
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "f-row",
                                      staticStyle: { gap: "5px" },
                                    },
                                    [
                                      _c("div", {
                                        staticStyle: {
                                          width: "20px",
                                          height: "20px",
                                        },
                                        style: { background: item.color },
                                      }),
                                      _c("div", [_vm._v(_vm._s(item.label))]),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._m(4),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "section f-row",
                staticStyle: { gap: "50px", "margin-top": "-20px" },
              },
              [
                _vm._m(5),
                _vm.$parent.datasets
                  ? _c("matkp-anatomogram", {
                      attrs: { data: _vm.$parent.datasets },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section f-row", staticStyle: { gap: "50px" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "f-col",
                    staticStyle: { width: "270px", gap: "20px" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "f-col", staticStyle: { gap: "10px" } },
                      [
                        _c("div", { staticClass: "section-title" }, [
                          _vm._v("Collaborate"),
                        ]),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(_vm.$parent.content.collaborate),
                          },
                        }),
                      ]
                    ),
                    _vm._m(6),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "f-col",
                    staticStyle: { flex: "1", gap: "10px" },
                  },
                  [
                    _c("div", { staticClass: "section-title" }, [
                      _vm._v("Latest News"),
                    ]),
                    _vm.$parent.newsFeed
                      ? _c(
                          "div",
                          { staticClass: "news-items" },
                          [
                            _vm._l(_vm.$parent.newsFeed, function (item) {
                              return _c(
                                "div",
                                { staticClass: "news-item f-row" },
                                [
                                  _c("div", {
                                    staticClass: "news-thumbnail contain",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        item.field_thumbnail_image
                                      ),
                                    },
                                  }),
                                  _c("div", { staticClass: "f-col" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: `${_vm.$parent.content.news.newsItemUrl}${item.nid}`,
                                        },
                                      },
                                      [
                                        _c("div", {}, [
                                          _vm._v(_vm._s(item.title)),
                                        ]),
                                      ]
                                    ),
                                    _c("div", {
                                      domProps: {
                                        innerHTML: _vm._s(item.body),
                                      },
                                    }),
                                  ]),
                                ]
                              )
                            }),
                            _c(
                              "a",
                              {
                                staticStyle: { "align-self": "flex-end" },
                                attrs: {
                                  href: `${_vm.$parent.content.news.newsUrl}`,
                                },
                              },
                              [_vm._v("See All News")]
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                ),
              ]
            ),
          ]
        ),
        _c("matkp-footer"),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "logo f-row align-v-center" }, [
      _c("img", {
        attrs: {
          src: "https://hugeampkpncms.org/sites/default/files/users/user32/matkp/matkplll.png",
        },
      }),
      _c(
        "div",
        {
          staticStyle: {
            "font-size": "30px",
            "line-height": "30px",
            "font-weight": "bold",
          },
        },
        [
          _vm._v(" Mammalian"),
          _c("br"),
          _vm._v(" Adipose"),
          _c("br"),
          _vm._v(" Tissue"),
          _c("br"),
          _c(
            "span",
            {
              staticStyle: {
                "font-size": "20px",
                display: "block",
                "font-weight": "normal",
                "white-space": "nowrap",
              },
            },
            [_vm._v(" Knowledge Portal ")]
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "f-row cards", staticStyle: { gap: "20px" } },
      [
        _c(
          "a",
          {
            staticClass: "f-col white-blur-bg yes-events",
            staticStyle: { gap: "5px", flex: "1" },
            attrs: { href: "/cellbrowser.html" },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  height: "125px",
                  padding: "20px",
                },
              },
              [
                _c("img", {
                  staticClass: "fit-img",
                  attrs: {
                    src: "https://hugeampkpncms.org/sites/default/files/images/matkp/matkp_sc.png",
                  },
                }),
              ]
            ),
            _c(
              "div",
              { staticStyle: { "font-size": "16px", "font-weight": "bold" } },
              [_vm._v("Single Cell Browser")]
            ),
            _c("div", [
              _vm._v(
                "Explore single-cell RNA-seq datasets from adipose tissue to examine cell types, gene expression, and marker genes."
              ),
            ]),
          ]
        ),
        _c(
          "a",
          {
            staticClass: "f-col white-blur-bg yes-events",
            staticStyle: { gap: "5px", flex: "1" },
            attrs: { href: "/bulkbrowser.html" },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  height: "125px",
                  padding: "20px",
                },
              },
              [
                _c("img", {
                  staticClass: "fit-img",
                  attrs: {
                    src: "https://hugeampkpncms.org/sites/default/files/images/matkp/matkp_de.png",
                  },
                }),
              ]
            ),
            _c(
              "div",
              { staticStyle: { "font-size": "16px", "font-weight": "bold" } },
              [_vm._v("Expression Browser")]
            ),
            _c("div", [
              _vm._v(
                "Compare gene expression in adipose tissue using bulk RNA-seq to identify differentially expressed genes and enriched pathways."
              ),
            ]),
          ]
        ),
        _c(
          "a",
          {
            staticClass: "f-col white-blur-bg yes-events",
            staticStyle: { gap: "5px", flex: "1" },
            attrs: { href: "/phenotype.html" },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  height: "125px",
                  padding: "20px",
                },
              },
              [
                _c("img", {
                  staticClass: "fit-img",
                  attrs: {
                    src: "https://hugeampkpncms.org/sites/default/files/images/matkp/matkp_p.png",
                  },
                }),
              ]
            ),
            _c(
              "div",
              { staticStyle: { "font-size": "16px", "font-weight": "bold" } },
              [_vm._v("Phenotype Browser")]
            ),
            _c("div", [
              _vm._v(
                "Browse adipose tissue–related phenotypes to examine genetic associations, implicated genes, and enriched pathways."
              ),
            ]),
          ]
        ),
        _c(
          "a",
          {
            staticClass: "f-col white-blur-bg yes-events",
            staticStyle: { gap: "5px", flex: "1" },
            attrs: { href: "/tissue.html" },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  height: "125px",
                  padding: "20px",
                },
              },
              [
                _c("img", {
                  staticClass: "fit-img",
                  attrs: {
                    src: "https://hugeampkpncms.org/sites/default/files/images/matkp/matkp_fa.png",
                  },
                }),
              ]
            ),
            _c(
              "div",
              { staticStyle: { "font-size": "16px", "font-weight": "bold" } },
              [_vm._v("Functional Annotations")]
            ),
            _c("div", [
              _vm._v(
                "Functional gene and regulatory annotations in adipose tissue; integrating gene expression, GWAS signals, and epigenomic data."
              ),
            ]),
          ]
        ),
        _c(
          "a",
          {
            staticClass: "f-col white-blur-bg yes-events",
            staticStyle: { gap: "5px", flex: "1" },
            attrs: { href: "/adipogenesis.html" },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  height: "125px",
                  padding: "20px",
                },
              },
              [
                _c("img", {
                  staticClass: "fit-img",
                  attrs: {
                    src: "https://hugeampkpncms.org/sites/default/files/images/matkp/matkp_a.png",
                  },
                }),
              ]
            ),
            _c(
              "div",
              { staticStyle: { "font-size": "16px", "font-weight": "bold" } },
              [_vm._v("Adipogenesis")]
            ),
            _c("div", [
              _vm._v(
                "Investigate gene expression programs underlying adipogenesis using interactive time-course datasets."
              ),
            ]),
          ]
        ),
        _c(
          "a",
          {
            staticClass: "f-col white-blur-bg yes-events",
            staticStyle: { gap: "5px", flex: "1" },
            attrs: { href: "/transcriptomics.html?gene=LEP" },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  height: "125px",
                  padding: "20px",
                },
              },
              [
                _c("img", {
                  staticClass: "fit-img",
                  attrs: {
                    src: "https://hugeampkpncms.org/sites/default/files/images/matkp/matkp_csc.png",
                  },
                }),
              ]
            ),
            _c(
              "div",
              { staticStyle: { "font-size": "16px", "font-weight": "bold" } },
              [_vm._v("Cross-Study Comparator")]
            ),
            _c("div", [
              _vm._v(
                "Explore differential expression across meta-analyzed curated bulk RNA-seq studies in humans and mice."
              ),
            ]),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "f-col", staticStyle: { gap: "5px", width: "225px" } },
      [
        _c(
          "div",
          { staticStyle: { "font-size": "16px", "font-weight": "bold" } },
          [_vm._v("Browse Data")]
        ),
        _c("div", { staticStyle: { flex: "1" } }, [
          _vm._v(
            "Browse and filter curated adipose tissue datasets across species, depots, assays, and experimental methods. Access detailed metadata and explore datasets available throughout the portal."
          ),
        ]),
        _c(
          "a",
          { staticClass: "yes-events", attrs: { href: "/datasets.html" } },
          [_vm._v("Browse All")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { id: "data-viz-labels" } }, [
      _c("div", [_vm._v("Datasets")]),
      _c("div", [_vm._v("Species")]),
      _c("div", [_vm._v("Data Type")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "f-col",
        staticStyle: {
          gap: "5px",
          padding: "40px",
          width: "250px",
          background: "#ffffffcc",
          height: "-webkit-fill-available",
        },
      },
      [
        _c(
          "div",
          { staticStyle: { "font-size": "16px", "font-weight": "bold" } },
          [_vm._v("Contribute Data")]
        ),
        _c("div", { staticStyle: { flex: "1" } }, [
          _vm._v("Upload your data through our Data Registry."),
        ]),
        _c(
          "a",
          {
            staticClass: "yes-events",
            attrs: { target: "_blank", href: "https://uploads.matkp.org" },
          },
          [_vm._v("Try it here")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "f-col", staticStyle: { gap: "20px" } }, [
      _c("div", { staticClass: "section-title" }, [
        _vm._v("Where is adipose tissue found?"),
      ]),
      _c("div", [
        _vm._v(
          " Adipose tissue (AT) is found throughout the body in aggregates referred to as depots. Broadly speaking, AT can be divided into subcutaneous depots (found under the skin) and visceral depots (found in the peritoneal and thoracic cavities). There are, however, other depots that are not clearly categorized as subcutaneous or visceral, such as around blood vessels (perivascular), within joints (intra-articular), and in bone marrow. "
        ),
        _c("a", { attrs: { href: "/info.html?page=adipose" } }, [
          _vm._v("Learn more."),
        ]),
      ]),
      _c("em", [
        _vm._v(
          " Select a species to the right, then mouse over the depots lists for more information. "
        ),
      ]),
      _c("em", [_vm._v("Click on depots to see (N) associated datasets. ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "f-col", staticStyle: { gap: "10px" } }, [
      _c("div", { staticClass: "section-title" }, [
        _vm._v("Related Resources"),
      ]),
      _c("div", [
        _vm._v(
          "MATKP and ATKP provide complementary views on adipose tissue biology."
        ),
        _c("br"),
        _c(
          "a",
          {
            attrs: { target: "_blank", href: "https://hugeamp.org/r/eat_bio" },
          },
          [_vm._v("Learn More")]
        ),
        _c("br"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }